// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SlotSelector.css */

.slot-selector-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .slot-selector-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .slot-selector-header p {
    font-weight: 600;
    color: #333;
  }
  
  .slot-count {
    font-size: 0.9rem;
    color: #2c3e50;
    font-weight: 500;
  }
  
  /* Scrollable container */
  .slot-scroll-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    max-height: 220px;
    overflow-y: auto;
    border: 1px solid #ccc;
    padding: 12px;
    border-radius: 8px;
    background-color: #fafafa;
  }
  
  /* Individual slot styles */
  .slot-item {
    flex: 0 0 auto;
    padding: 10px 14px;
    background-color: #ffffff;
    border: 1px solid #ccc;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 0.95rem;
    min-width: 140px;
    text-align: center;
    -webkit-user-select: none;
            user-select: none;
  }
  
  .slot-item:hover {
    background-color: #f0f0f0;
    border-color: var(--clr-primary-3);
  }
  
  .slot-item.selected {
    background-color: var(--clr-primary-3);
    color: #fff;
    font-weight: bold;
    border-color: var(--clr-primary-3);
  }
  
  /* Disabled slots */
  .slot-item.disabled {
    background-color: #eee;
    color: #999;
    border-color: #ddd;
    cursor: not-allowed;
    pointer-events: none;
  }
  
  /* Break checkbox styling */
  .break-checkbox {
    margin-top: 16px;
    font-size: 0.95rem;
    color: #444;
  }
  
  .break-checkbox label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
  }
  
  .break-checkbox input[type="checkbox"] {
    transform: scale(1.1);
    cursor: pointer;
  }
  
  /* Responsive */
  @media (max-width: 480px) {
    .slot-item {
      min-width: 120px;
      padding: 8px 10px;
      font-size: 0.85rem;
    }
  
    .slot-scroll-container {
      max-height: 180px;
      padding: 10px;
    }
  }
  
  .station-tabs {
    display: flex;
    gap: 0.5rem;
    margin: 1rem 0;
    flex-wrap: wrap;
  }
  
  .station-tab {
    padding: 0.4rem 1rem;
    font-size: 0.95rem;
    font-weight: 500;
    background-color: var(--clr-grey-10);
    border: 1px solid var(--clr-grey-6);
    border-radius: var(--borderRadius);
    cursor: pointer;
    transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  }
  
  .station-tab:hover {
    background-color: var(--clr-primary-10);
    color: var(--clr-primary-1);
    border-color: var(--clr-primary-7);
  }
  
  .station-tab.active {
    background-color: var(--clr-primary-5);
    color: white;
    border-color: var(--clr-primary-9);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  `, "",{"version":3,"sources":["webpack://./src/components/AdminScheduling/SchedulingStyles/SlotSelector.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA,yBAAyB;EACzB;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA,2BAA2B;EAC3B;IACE,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,kCAAkC;EACpC;;EAEA;IACE,sCAAsC;IACtC,WAAW;IACX,iBAAiB;IACjB,kCAAkC;EACpC;;EAEA,mBAAmB;EACnB;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA,2BAA2B;EAC3B;IACE,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA,eAAe;EACf;IACE;MACE,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,aAAa;IACf;EACF;;EAEA;IACE,aAAa;IACb,WAAW;IACX,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;IACpC,mCAAmC;IACnC,kCAAkC;IAClC,eAAe;IACf,+EAA+E;EACjF;;EAEA;IACE,uCAAuC;IACvC,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,sCAAsC;IACtC,YAAY;IACZ,kCAAkC;IAClC,wCAAwC;EAC1C","sourcesContent":["/* SlotSelector.css */\n\n.slot-selector-container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .slot-selector-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .slot-selector-header p {\n    font-weight: 600;\n    color: #333;\n  }\n  \n  .slot-count {\n    font-size: 0.9rem;\n    color: #2c3e50;\n    font-weight: 500;\n  }\n  \n  /* Scrollable container */\n  .slot-scroll-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    max-height: 220px;\n    overflow-y: auto;\n    border: 1px solid #ccc;\n    padding: 12px;\n    border-radius: 8px;\n    background-color: #fafafa;\n  }\n  \n  /* Individual slot styles */\n  .slot-item {\n    flex: 0 0 auto;\n    padding: 10px 14px;\n    background-color: #ffffff;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-size: 0.95rem;\n    min-width: 140px;\n    text-align: center;\n    user-select: none;\n  }\n  \n  .slot-item:hover {\n    background-color: #f0f0f0;\n    border-color: var(--clr-primary-3);\n  }\n  \n  .slot-item.selected {\n    background-color: var(--clr-primary-3);\n    color: #fff;\n    font-weight: bold;\n    border-color: var(--clr-primary-3);\n  }\n  \n  /* Disabled slots */\n  .slot-item.disabled {\n    background-color: #eee;\n    color: #999;\n    border-color: #ddd;\n    cursor: not-allowed;\n    pointer-events: none;\n  }\n  \n  /* Break checkbox styling */\n  .break-checkbox {\n    margin-top: 16px;\n    font-size: 0.95rem;\n    color: #444;\n  }\n  \n  .break-checkbox label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: 500;\n  }\n  \n  .break-checkbox input[type=\"checkbox\"] {\n    transform: scale(1.1);\n    cursor: pointer;\n  }\n  \n  /* Responsive */\n  @media (max-width: 480px) {\n    .slot-item {\n      min-width: 120px;\n      padding: 8px 10px;\n      font-size: 0.85rem;\n    }\n  \n    .slot-scroll-container {\n      max-height: 180px;\n      padding: 10px;\n    }\n  }\n  \n  .station-tabs {\n    display: flex;\n    gap: 0.5rem;\n    margin: 1rem 0;\n    flex-wrap: wrap;\n  }\n  \n  .station-tab {\n    padding: 0.4rem 1rem;\n    font-size: 0.95rem;\n    font-weight: 500;\n    background-color: var(--clr-grey-10);\n    border: 1px solid var(--clr-grey-6);\n    border-radius: var(--borderRadius);\n    cursor: pointer;\n    transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n  }\n  \n  .station-tab:hover {\n    background-color: var(--clr-primary-10);\n    color: var(--clr-primary-1);\n    border-color: var(--clr-primary-7);\n  }\n  \n  .station-tab.active {\n    background-color: var(--clr-primary-5);\n    color: white;\n    border-color: var(--clr-primary-9);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
